import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { DocumentService } from 'src/app/shared/document.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DocumentTemplateListView } from './document-template-list.view';
import { DocumentTemplateListDataService } from './document-template-list.data';

@observer
export class DocumentTemplateListController extends React.Component<ControllerProps<any>, any> {
    @resolve
    documentService: DocumentService;

    @resolve
    toast: ToastNotifications;

    @observable
    dataService: DocumentTemplateListDataService;

    constructor(props: ControllerProps<any>) {
        super(props);
    }

    @autobind
    private async loadData(): Promise<void> {
        this.dataService = DocumentTemplateListDataService.make();

        this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.pageSize = 25;

        await this.dataService.load(query => query);
    }

    @autobind
	downloadTemplate(record: IDocumentTemplateSummary): void {
        this.documentService.downloadTemplate(record);
    }

    @autobind
    onItemDoubleClicked(item: IDocumentTemplateSummary | "Document" | "Report"): void {
		this.props.history.push(`/general/document-templates/${item == 'Document' || item == 'Report' ? item : item.id}`);
    }

    componentDidMount() {
        this.props.setBusy(true);

        this.loadData()
            .catch((error) => {
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            })
            .then(() => {
                this.props.setBusy(false);
            });
    }

    render() {
        return (
            <DocumentTemplateListView
                model={this.dataService}
                setBusy={this.props.setBusy}
                downloadTemplate={this.downloadTemplate}
                onItemDoubleClicked={this.onItemDoubleClicked}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/list/document-template-list.controller.tsx